import { XMarkIcon } from '@heroicons/react/24/solid'

export const CloseButton = ({ setIsLoginOpen }: CloseButtonProps) => {
  return (
    <button
      onClick={() => setIsLoginOpen(false)}
      className="absolute top-4 right-4 p-1 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors duration-200 cursor-pointer"
      aria-label="Close modal"
    >
      <XMarkIcon className="w-5 h-5" />
    </button>
  )
}

interface CloseButtonProps {
  setIsLoginOpen: (open: boolean) => void
}
